import { defineStore } from 'pinia';

export const useLoaderStore = defineStore('loader', {
  state: () => ({
    globalLoading: false,
    buttonLoading: {}, // ключ - идентификатор кнопки
  }),
  actions: {
    /**
     * Показывает глобальный лоадер.
     */
    showGlobal() {
      this.globalLoading = true;
    },
    /**
     * Скрывает глобальный лоадер.
     */
    hideGlobal() {
      this.globalLoading = false;
    },
    /**
     * Устанавливает состояние загрузки для конкретной кнопки.
     * @param {string} key - Идентификатор кнопки.
     * @param {boolean} value - Состояние загрузки.
     */
    setButtonLoading(key, value) {
      this.buttonLoading[key] = value;
    },
  },
});